import { createContext } from "react";
import { noop } from "@common/helpers/function";
import { ClientDetailsRow } from "../views/clientViewConfig";

export interface ClientBulkSelectionContextValue {
    selectedCount: number;
    selected: ClientDetailsRow[];
    select(clientOrClients: ClientDetailsRow | ClientDetailsRow[]): void;
    deselect(clientOrClients: ClientDetailsRow | ClientDetailsRow[]): void;
    isSelected(client: ClientDetailsRow): boolean;
    clearSelection(): void;
}

export const clientBulkSelectionContext =
    createContext<ClientBulkSelectionContextValue>({
        selected: [],
        selectedCount: 0,
        select: noop,
        deselect: noop,
        isSelected: () => false,
        clearSelection: noop,
    });
